import { EuiBadge } from '@elastic/eui'
import { TableColumn } from './Table'
import { useTranslation } from 'react-i18next'

type TableBooleanColumnProps = {
    value: boolean
}

export const TableBooleanColumn = (props: TableBooleanColumnProps) => {
    const { t } = useTranslation(['common'])

    return (
        <EuiBadge
            className="ignore-color-css"
            color={props.value ? 'success' : 'danger'}
        >
            {props.value ? t('common:yes') : t('common:no')}
        </EuiBadge>
    )
}

type TableActionColumnProps = {
    editName?: string
    editDescription?: string
    deleteName?: string
    deleteDescription?: string
    viewName?: string
    viewDescription?: string
    customActions?: TableColumn['customActions']
    onView?: TableColumn['onView']
    onEdit?: TableColumn['onEdit']
    onDelete?: TableColumn['onDelete']
}

export const getTableActions = (props: TableActionColumnProps) => {
    const actions = []

    if (props.customActions) {
        props.customActions.forEach((action) => {
            actions.push({
                name: action.label,
                description: action.description,
                icon: action.icon,
                type: 'icon',
                onClick: action.onClick,
                enabled: action.enabled,
                available: action.available,
            })
        })
    }

    if (props.onView) {
        actions.push({
            name: props.viewName,
            description: props.viewDescription,
            icon: 'eye',
            type: 'icon',
            onClick: props.onView.onClick,
            enabled: props.onView.enabled,
            available: props.onView.available,
        })
    }

    if (props.onEdit) {
        actions.push({
            name: props.editName,
            description: props.editDescription,
            icon: 'pencil',
            type: 'icon',
            onClick: props.onEdit.onClick,
            enabled: props.onEdit.enabled,
            available: props.onEdit.available,
        })
    }

    if (props.onDelete) {
        actions.push({
            name: props.deleteName,
            description: props.deleteDescription,
            icon: 'trash',
            type: 'icon',
            color: 'danger',
            onClick: props.onDelete.onClick,
            enabled: props.onDelete.enabled,
            available: props.onDelete.available,
        })
    }

    return actions
}
